import React, { Suspense } from 'react'
import { GoogleMapsProvider } from '../context/GoogleMapContext';

const VehicleTrackLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <GoogleMapsProvider>
      <Suspense>{children}</Suspense>
    </GoogleMapsProvider>
  )
}
export default VehicleTrackLayout;